import { NetworkResultsTablePanel } from "#routes/organization/networks/[networkId]/detail/NetworkResultsTab/NetworkResultsTablePanel";
import { useStorageKey } from "#src/hooks/useStorageKey";
import React from "react";
import { NetworkUpdateStatusBanner } from "../NetworkUpdateStatusBanner";

export const NetworkResultsTab = () => {
  const [filterConfigStorageKey, tableConfigStorageKey, tableStateStorageKey] =
    useStorageKey(
      ["filter-configuration", "table-configuration", "table-state"],
      "network-calculation-results"
    );

  return (
    <>
      <NetworkUpdateStatusBanner />
      <NetworkResultsTablePanel
        filterConfigStorageKey={filterConfigStorageKey}
        tableConfigStorageKey={tableConfigStorageKey}
        tableStateStorageKey={tableStateStorageKey}
      />
    </>
  );
};
